import { localizeDate } from '@/utils/date';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';

export default {
  data: function () {
    return {
      deletePrompt: false,
      // item for deletion
      selectedItem: {},

      list: [],
      isFetching: false,
      serverItemsLength: -1,
      searchItem: null,
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
  },
  watch: {
    tableOptions: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
    searchItem: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList();
    }, 500),
  },
  created() {
    if (this.disableFetchOnCreatedMixin !== true) {
      this.fetchList();
    }
  },
  methods: {
    niota1ImageUrl(imagePath) {
      if (imagePath) {
        if (/^http(?:s):\/\//i.test(imagePath)) {
          return imagePath;
        }

        if (!imagePath.startsWith('/')) {
          imagePath = `/${imagePath}`;
        }

        return `${location.origin}${imagePath}`;
      }
      return '';
    },
    localizeDate,
    showDeletePrompt(item) {
      this.selectedItem = cloneDeep(item);
      this.deletePrompt = true;
    },
    closeDeletePrompt() {
      this.selectedItem == null;
      this.deletePrompt = false;
    },
    deleteItem() {
      this.deletePrompt = false;
      this.deletePromise()
        .then(() => {
          this.$snack(this.$i18n_t('Common.snacks.deleteSuccess'), 'success');
          this.fetchList();
        })
        .catch((error) => {
          console.error(this.$i18n_t('Common.snacks.deleteFailed'), error);
          if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
            this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
          } else {
            this.$snack(this.$i18n_t('Common.snacks.deleteFailed'), 'error');
          }
        });
    },
    setCurrentTablePage(value) {
      this.tableOptions.page = value;
    },
  },
};
